(function () {
  function isVisible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  function ensureIOSAttrs(video) {
    if (!video) return;
    // Make autoplay eligibility as strong as possible on iOS/Safari
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;

    video.setAttribute("muted", "");
    video.setAttribute("defaultmuted", "");
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");
    video.setAttribute("autoplay", "");

    // preload hint (doesn't force download everywhere, but helps)
    if (!video.getAttribute("preload")) video.setAttribute("preload", "metadata");
  }

  function pickActiveVideo(bannerEl) {
    var vids = bannerEl.querySelectorAll('video.js-video[data-type="html"]');
    if (!vids.length) return null;

    // Prefer the one that is actually visible (CSS-controlled desktop/mobile)
    for (var i = 0; i < vids.length; i++) {
      if (isVisible(vids[i])) return vids[i];
    }
    // Fallback: desktop first
    return vids[0];
  }

  function tryPlay(video, bannerEl) {
    if (!video) return;

    ensureIOSAttrs(video);

    // If sources are present but not yet loaded, hint load.
    // (Safe no-op in most browsers.)
    try {
      if (video.readyState === 0) video.load();
    } catch (e) {}

    // Attempt play
    var p;
    try {
      p = video.play();
    } catch (e) {
      bannerEl && bannerEl.classList.add("general-banner--video-fallback");
      return;
    }

    // If play() returned a Promise, handle rejections (common on iOS autoplay policy)
    if (p && typeof p.then === "function") {
      p.catch(function () {
        // Leave poster showing; mark fallback state
        bannerEl && bannerEl.classList.add("general-banner--video-fallback");
      });
    }
  }

  function init() {
    var banners = document.querySelectorAll(".js-general-banner");
    if (!banners.length) return;

    banners.forEach(function (banner) {
      var video = pickActiveVideo(banner);
      if (!video) return;

      // Try immediately
      tryPlay(video, banner);

      // Try again once it can play (covers timing races on iOS)
      var onCanPlay = function () {
        tryPlay(video, banner);
        video.removeEventListener("canplay", onCanPlay);
      };
      video.addEventListener("canplay", onCanPlay, { once: true });
    });
  }

  // Initial load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }

  // BFCache / returning to page on iOS
  window.addEventListener("pageshow", function () {
    init();
  });

  // If user returns to the tab, retry (iOS pauses media aggressively)
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") init();
  });
})();
